import { warn, Component, Widget, _decorator, Canvas } from 'cc';

const { ccclass, requireComponent } = _decorator;

@ccclass('WidgetBindCanvas')
@requireComponent(Widget)
export default class WidgetBindCanvas extends Component {
    private _widget: Widget = null;

    public onLoad(): void {
        this._widget = this.getComponent(Widget);
        this._bindWidgetTarget();
    }

    public setWidgetTarget(canvas: Canvas) {
        this._widget = this.getComponent(Widget);
        this._widget.target = canvas.node;
    }

    private _bindWidgetTarget() {
        const canvas = this.node.scene.getComponentInChildren(Canvas);
        if (canvas && canvas.node) {
            this.setWidgetTarget(canvas);
        } else {
            warn('WidgetBindCanvas: No canvas found in the scene. Widget target cannot be set.');
        }
    }
}
